import { render, staticRenderFns } from "./home-old.vue?vue&type=template&id=88900476&"
import script from "./home-old.vue?vue&type=script&lang=js&"
export * from "./home-old.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports